import React from 'react';
import Countdown from 'react-countdown';
import { Link, NavLink } from 'react-router-dom';
import i18n from '../../../../../i18n';
import {
  checkUserValidity,
  checkUserValidityGn,
  sendNotification,
  bidNow,
  getTopBidders,
  extraTimeCheck,
  toggleAutoBid,
} from '../../../../../models/auctions';
import { getLoggedUser } from '../../../../../state/user';
import { Modal } from 'react-bootstrap';
import { formatCurrency } from '../../../../../state/utils';
import ToggleButton from 'react-toggle-button';
import swal from 'sweetalert';
import { User } from 'lucide-react';
import { BiddersPositionNew } from './BiddersPosition';
import { OmrRiyal } from '../../../../common/icons';
import '../../../../../styles/components/auction-details.scss';

const is_logged = localStorage.getItem('is_logged_in') ? true : false;
const user = getLoggedUser();

let lang = localStorage.getItem('I18N_LANGUAGE');

/* ── Flip card (inlined) ────────────────────────────────────────────── */

const pad = (n) => String(n).padStart(2, '0');

function Separator() {
  return (
    <div className="fliqlo-separator">
      <div className="fliqlo-dot" />
      <div className="fliqlo-dot" />
    </div>
  );
}

class FlipCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = { display: props.value, prev: props.value, flipping: false };
    this.flipTimeout = null;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      if (this.flipTimeout) clearTimeout(this.flipTimeout);
      this.setState({ prev: this.state.display, flipping: true });
      this.flipTimeout = setTimeout(() => {
        this.setState({ display: this.props.value, flipping: false });
      }, 400);
    }
  }

  componentWillUnmount() {
    if (this.flipTimeout) clearTimeout(this.flipTimeout);
  }

  render() {
    const { label } = this.props;
    const { display, prev, flipping } = this.state;
    const flipTop = flipping ? prev : display;
    const flipBottom = flipping ? this.props.value : display;

    return (
      <div className="fliqlo-card-wrapper">
        <div className="fliqlo-card">
          <div className="fliqlo-half fliqlo-half--top">
            <span className="fliqlo-digit fliqlo-digit--top">{display}</span>
          </div>
          <div className="fliqlo-half fliqlo-half--bottom">
            <span className="fliqlo-digit fliqlo-digit--bottom">{display}</span>
          </div>
          <div
            className={
              'fliqlo-half fliqlo-half--top fliqlo-flip-top' +
              (flipping ? ' fliqlo-flip-top--active' : '')
            }
          >
            <span className="fliqlo-digit fliqlo-digit--top">{flipTop}</span>
          </div>
          <div
            className={
              'fliqlo-half fliqlo-half--bottom fliqlo-flip-bottom' +
              (flipping ? ' fliqlo-flip-bottom--active' : '')
            }
          >
            <span className="fliqlo-digit fliqlo-digit--bottom">{flipBottom}</span>
          </div>
          <div className="fliqlo-centre-line" />
        </div>
        <span className="fliqlo-label">{label}</span>
      </div>
    );
  }
}

/* ── Main component ─────────────────────────────────────────────────── */

export class BiddingCompNew extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show_auto_bid_panel: false,
      is_saving: false,
      auto_bidding: false,
      bidTimeStopped: false,
      toggleArrow: false,
      bid_increment: 0,
      auto_bid_increment: 0,
      current_bid_amount: 0,
      user_bid_amount: 0,
      target_amount: 0,
      left_button_disable: true,
      is_bid_sending: false,
      bid_place_message: '',
      bid_place_error: false,
      is_loading: false,
      user_valid: false,
      date_out_of_range: false,
      need_enroll: true,
      bid_count: 0,
      winner: {},
      is_completed: false,
      auction_page: '',
      top_bidders: {},
      enroll_status: '',
      startDate: null,
      endDate: null,
      extra_time_message: false,
      show_auto_bid_info: false,
      increments: [1000, 2000, 5000, 10000, 15000, 20000],
      total_enrolls: 0,
      now: new Date(),
    };

    this.incrementNumber = this.incrementNumber.bind(this);
    this.decrementNumber = this.decrementNumber.bind(this);
    this.incrementAutoBidNumber = this.incrementAutoBidNumber.bind(this);
    this.decrementAutoBidNumber = this.decrementAutoBidNumber.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.bidNow = this.bidNow.bind(this);
    this.auctionFinished = this.auctionFinished.bind(this);
    this.checkUserAuctionValidity = this.checkUserAuctionValidity.bind(this);
    this.loadTopBidders = this.loadTopBidders.bind(this);
    this.checkTime = this.checkTime.bind(this);
    this.saveAutoBidOption = this.saveAutoBidOption.bind(this);
    this.incrementTime = this.incrementTime.bind(this);
  }

  componentDidMount() {
    let auction = this.props.auction;
    let bid_increment = 0;
    if (auction.bid_increment) {
      bid_increment = auction.bid_increment;
      this.setState({ bid_increment: bid_increment });
    }
    let auto_bid_increment = bid_increment;
    if (auction.auto_bid_increment) {
      auto_bid_increment = parseFloat(auction.auto_bid_increment);
    }
    this.setState({ auto_bid_increment });

    let start_amount = parseFloat(auction.current_amount);
    let current_bid_amount = parseFloat(start_amount);
    if (auction.latest_bid && auction.latest_bid.bid_amount) {
      current_bid_amount = parseFloat(auction.latest_bid.bid_amount);
    }
    let bid_count = auction.bid_count;
    let winner = auction.winner;
    let is_completed = auction.is_completed;
    let auction_page = this.props.auction_page;
    start_amount = parseFloat(start_amount) + parseFloat(bid_increment);
    let increments = auction.increment_numbers;
    this.setState({
      user_bid_amount: start_amount,
      target_amount: start_amount.toFixed(2),
      current_bid_amount,
      is_loading: true,
      bid_count,
      winner,
      is_completed,
      auction_page,
      startDate: auction.start_date,
      endDate: auction.end_date,
      increments: increments,
    });

    this.checkUserAuctionValidity();

    if (auction && auction.target_amount) {
      this.setState({ target_amount: auction.target_amount });
    }
    this.setState({ auto_bidding: auction.enabled_auto_bidding });

    if (this.props.isPrimary !== false) {
      this.startIntervals();
    }
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.isPrimary !== this.props.isPrimary) {
      if (this.props.isPrimary !== false) {
        this.startIntervals();
      } else {
        this.stopIntervals();
      }
    }
  }

  componentWillUnmount() {
    this.stopIntervals();
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  }
  startIntervals() {
    let auction = this.props.auction;
    if (auction && auction.id && !this.state.refreshInterval) {
      this.loadTopBidders();
      let refreshInterval = setInterval(this.loadTopBidders, 10000);
      this.setState({ refreshInterval });
    }
    if (!this.state.intervalId) {
      let intervalId = setInterval(this.checkTime, 5000);
      this.setState({ intervalId });
    }
    if (!this.state.serverTimeId) {
      let serverTimeId = setInterval(this.incrementTime, 1000);
      this.setState({ serverTimeId });
    }
  }
  stopIntervals() {
    clearInterval(this.state.intervalId);
    clearInterval(this.state.refreshInterval);
    clearInterval(this.state.serverTimeId);
    this.setState({ intervalId: null, refreshInterval: null, serverTimeId: null });
  }

  handleVisibilityChange = () => {
    if (document.visibilityState === 'visible' && this.props.isPrimary !== false) {
      this.checkTime();
      this.loadTopBidders();
    }
  };
  createDate(dt) {
    return dt ? new Date(String(dt).replace(/-/g, '/')) : null;
  }

  getServerTime() {
    let { auction } = this.props;
    if (!auction || !auction.server_time) return new Date();
    return typeof auction.server_time === 'string'
      ? this.createDate(auction.server_time)
      : new Date(auction.server_time);
  }

  incrementTime() {
    let { auction } = this.props;
    if (!auction) return;
    let dt = this.getServerTime();
    dt.setSeconds(dt.getSeconds() + 1);
    auction.server_time = dt;
    this.setState({});
  }

  async checkUserAuctionValidity() {
    let auction = this.props.auction;
    if (auction && auction.id) {
      this.setState({ is_loading: true });
      let response = await checkUserValidityGn({ auction: auction.id });
      if (is_logged) {
        response = await checkUserValidity({ auction: auction.id });
      }
      let data = response.data;
      if (data) {
        this.setState({
          user_valid: data.valid,
          date_out_of_range: data.date_out_of_range,
          is_loading: false,
          total_enrolls: data.total_enrolls,
        });
        if (data.enroll) {
          this.setState({ need_enroll: false });
        }
        if (data.enroll_status && data.enroll_status !== 'C') {
          this.setState({ enroll_status: data.enroll_status });
        }
      }
    }
  }

  async auctionFinished() {
    let auction = this.props.auction;
    await sendNotification({ auction: auction.id });
  }

  async checkTime() {
    let auction = this.props.auction;
    let endDate = this.state.endDate;
    if (!auction || !auction.id || !endDate) return;

    let now = this.getServerTime();
    let endDt = this.createDate(endDate);
    if (!endDt) return;

    var diff = Math.abs(endDt - now);
    var minutes = Math.floor(diff / 1000 / 60);

    if (minutes < 2) {
      const response = await extraTimeCheck({ auction: auction.id });
      let data = response.data;
      if (!data || typeof data.end_date === 'undefined') return;

      var g1 = this.createDate(endDate);
      var g2 = this.createDate(data.end_date);

      if (
        g1 &&
        g2 &&
        g1.getTime() !== g2.getTime() &&
        !this.state.bidTimeStopped &&
        !this.state.extra_time_message
      ) {
        this.setState({
          endDate: data.end_date,
          extra_time_message: true,
        });

        setTimeout(() => {
          this.setState({ extra_time_message: false });
        }, 3000);
      }
    }
  }

  handleChange(event) {
    let state = this.state;
    state[event.target.name] = event.target.value;
    this.setState({ state });
    if (event.target.name === 'bid_increment') {
      this.setCurrentBidAmount(event.target.value);
    }
  }

  setCurrentBidAmount(new_incr) {
    let user_bid_amount = this.state.user_bid_amount;
    let current_amount = parseFloat(this.state.current_bid_amount);
    user_bid_amount = parseFloat(current_amount) + parseFloat(new_incr);
    this.setState({ user_bid_amount });
  }

  decrementNumber() {
    let current_amount = parseFloat(this.state.current_bid_amount);
    let user_bid_amount = parseFloat(this.state.user_bid_amount);
    let bid_increment = parseFloat(this.state.bid_increment);
    user_bid_amount = parseFloat(user_bid_amount) - parseFloat(bid_increment);
    let left_button_disable = false;
    let minAmount = parseFloat(current_amount) + parseFloat(bid_increment);
    if (user_bid_amount <= minAmount) {
      left_button_disable = true;
    }
    this.setState({
      user_bid_amount: user_bid_amount,
      left_button_disable: left_button_disable,
    });
  }

  incrementNumber() {
    let current_amount = parseFloat(this.state.current_bid_amount);
    let user_bid_amount = parseFloat(this.state.user_bid_amount);
    let bid_increment = parseFloat(this.state.bid_increment);
    user_bid_amount = parseFloat(user_bid_amount) + parseFloat(bid_increment);
    let left_button_disable = true;
    if (user_bid_amount > current_amount) {
      left_button_disable = false;
    }
    this.setState({
      user_bid_amount: user_bid_amount,
      left_button_disable: left_button_disable,
    });
  }

  decrementAutoBidNumber() {
    let { target_amount, current_bid_amount, bid_increment, auto_bid_increment } = this.state;
    let minAmount = parseFloat(current_bid_amount) + parseFloat(bid_increment);
    target_amount = parseFloat(target_amount) - parseFloat(auto_bid_increment);
    if (target_amount <= minAmount) {
      swal('Not Allowed', 'Amount should be greater than current amount', 'error');
      return;
    }
    this.setState({ target_amount: target_amount.toFixed(2) });
  }

  incrementAutoBidNumber() {
    let target_amount = parseFloat(this.state.target_amount);
    let bid_increment = parseFloat(this.state.auto_bid_increment);
    target_amount = parseFloat(target_amount) + parseFloat(bid_increment);
    this.setState({ target_amount: target_amount.toFixed(2) });
  }

  async bidNow() {
    this.setState({ is_bid_sending: true });
    let auction = this.props.auction;
    let user_bid_amount = this.state.user_bid_amount;
    const response = await bidNow({ user_bid_amount, auction: auction.id });
    let data = response.data;
    let current_amount = data.current_amount;
    let message =
      lang === 'ar' && response.meta.message_ar && response.meta.message_ar.trim() !== ''
        ? response.meta.message_ar
        : response.message;
    this.setState({
      current_bid_amount: current_amount,
      bid_place_message: message,
      bid_place_error: data.bid_place_error,
    });

    if (data) {
      this.setState({ is_bid_sending: false });
      this.checkTime();
    }
    setTimeout(() => {
      this.setState({
        bid_place_message: '',
        bid_place_error: false,
      });
    }, 5000);

    this.loadTopBidders();
  }

  async loadTopBidders() {
    let auction = this.props.auction;
    if (auction) {
      this.setState({ loading: true, refresh_loading: true });
      const response = await getTopBidders({ auction: auction.id });
      let data = response.data;
      this.setState({ top_bidders: data });
      if (response) {
        this.setState({ refresh_loading: false });
      }
      if (response && response.meta && response.meta.bid_amount) {
        let current_bid_amount = parseFloat(response.meta.bid_amount);
        let bid_count = response.meta.bid_count;
        let user_bid_amount = parseFloat(current_bid_amount) + parseFloat(this.state.bid_increment);

        this.props.onAmountUpdate(current_bid_amount);

        this.setState({
          current_bid_amount,
          user_bid_amount,
          bid_count,
        });
        if (this.props.updateRow && typeof this.props.updateRow === 'function') {
          this.props.updateRow(bid_count);
        }
      }
      if (response && response.meta && response.meta.myPosition) {
        let myBidData = response.meta.myPosition;
        this.setState({
          myPosition: myBidData.position,
          myPrice: myBidData.bid_amount,
        });
      }

      if (response && response.meta && response.meta.total_enrolls) {
        this.setState({ total_enrolls: response.meta.total_enrolls });
      }

      if (response && response.meta && response.meta.extra_time) {
        this.checkTime();
      }
    }
  }

  async saveAutoBidOption() {
    this.setState({ is_saving: true });
    let { target_amount, auto_bidding, auto_bid_increment } = this.state;
    if (!auto_bidding) {
      target_amount = null;
    }
    let { auction } = this.props;
    const response = await toggleAutoBid({
      target_amount,
      auto_bidding,
      auction: auction.id,
      increment: auto_bid_increment,
    });
    if (response.success) {
      this.setState({ is_saving: false });
    } else {
      this.setState({ is_saving: false });
    }
  }

  getCountdownInfo() {
    const { startDate, endDate } = this.state;
    const now = this.getServerTime();
    const startDt = this.createDate(startDate);

    if (startDt && now < startDt) {
      return { date: startDt, label: i18n.t('starts_after') || 'Starts in', mode: 'start' };
    }

    const endDt = this.createDate(endDate);
    return { date: endDt, label: i18n.t('ends_after') || 'Ends in', mode: 'end' };
  }

  render() {
    let auction = this.props.auction;
    let { auto_bidding, current_bid_amount } = this.state;
    let reg_status = auction.registartion_status;
    let increments = this.state.increments;
    let total_enrolls = this.state.total_enrolls;
    let countdownInfo = this.getCountdownInfo();

    return (
      <React.Fragment>
        <div className="bc-wrap">
          {/* Amounts header */}
          <div className="bc-amounts-header">
            <div className="bc-amounts-row">
              <div className="bc-amount-cell">
                <span className="bc-amount-cell__label">{i18n.t('current_amount')}</span>
                <span className="bc-amount-cell__value bc-amount-cell__value--current">
                  {formatCurrency(current_bid_amount || auction.current_amount)}
                  <span style={{ fontSize: 11, fontWeight: 500, marginLeft: 4, opacity: 0.85 }}>
                    <OmrRiyal />
                  </span>
                </span>
              </div>
              {this.state.myPosition && (
                <div className="bc-amount-cell">
                  <span className="bc-amount-cell__label">{i18n.t('my_rank')}</span>
                  <span
                    className="bc-amount-cell__value bc-amount-cell__value--current"
                    key={this.state.myPosition}
                    style={{ transition: 'color 0.3s ease' }}
                  >
                    # {this.state.myPosition}
                  </span>
                </div>
              )}
            </div>

            {['A', 'F', 'PM', 'OM', 'GE', 'CE', 'GM'].includes(user?.role) ? (
              total_enrolls > 0 ? (
                <NavLink
                  to={`/enrollments/list?status=approved&group=${auction.group}`}
                  className="bc-enrolled-strip"
                >
                  <User size={14} />
                  {i18n.t('enrolled_bidders')} : {total_enrolls}
                </NavLink>
              ) : (
                <NavLink
                  to={`/enrollments/list?page=1&limit=15&group=${auction.group}&status=pending_mzadcom`}
                  className="bc-enrolled-strip"
                >
                  <User size={14} />
                  {i18n.t('enrolled_bidders')} : {total_enrolls}
                </NavLink>
              )
            ) : (
              // Regular users: only show the strip when there's actually something to show
              total_enrolls > 0 && (
                <div className="bc-enrolled-strip">
                  <User size={14} />
                  {i18n.t('enrolled_bidders')} : {total_enrolls}
                </div>
              )
            )}
          </div>

          {/* Countdown */}
          {countdownInfo.date && (
            <div className="bc-countdown-wrap">
              <div className="bc-countdown-label">{countdownInfo.label}</div>
              <Countdown
                key={countdownInfo.mode + '-' + countdownInfo.date.getTime()}
                date={countdownInfo.date.getTime()}
                now={() => this.getServerTime()}
                onComplete={() => {
                  if (countdownInfo.mode === 'end') {
                    this.setState({ bidTimeStopped: true });
                  } else {
                    // start date reached — re-evaluate on next tick, force a re-render
                    this.setState({});
                  }
                }}
                renderer={({ days, hours, minutes, seconds, completed }) => {
                  if (completed) {
                    if (countdownInfo.mode === 'end') {
                      return (
                        <div className="fliqlo-root">
                          <div className="fliqlo-finished">{i18n.t('bid_time_ends')}</div>
                        </div>
                      );
                    }
                    return null;
                  }
                  return (
                    <div className="fliqlo-root">
                      <div className="fliqlo-glow" />
                      <div className="fliqlo-row">
                        <FlipCard value={pad(days)} label={i18n.t('lbl_day')} />
                        <Separator />
                        <FlipCard value={pad(hours)} label={i18n.t('lbl_hour')} />
                        <Separator />
                        <FlipCard value={pad(minutes)} label={i18n.t('lbl_minute')} />
                        <Separator />
                        <FlipCard value={pad(seconds)} label={i18n.t('lbl_second')} />
                      </div>
                    </div>
                  );
                }}
              />
            </div>
          )}

          {/* Body */}
          <div className="bc-body">
            {is_logged && auction.status !== 'A' && (
              <div className="bc-status-msg bc-status-msg--not-active">
                <i className="fa fa-ban" />
                {i18n.t('not_active')}
              </div>
            )}

            {is_logged && auction.status === 'A' && (
              <>
                {/* Increment selector */}
                <div className="bc-incr-section">
                  <span className="bc-incr-label">
                    {i18n.t('incr_amount') || 'Select Increment'}
                  </span>
                  <div className="bc-incr-scroll-wrap">
                    <button
                      className="bc-incr-arrow"
                      onClick={() => this.setState({ toggleArrow: false })}
                    >
                      <i className="fa fa-chevron-left" />
                    </button>
                    <div className="bc-incr-list">
                      {increments.map((incr, i) => (
                        <button
                          key={i}
                          className={`bc-incr-btn ${Number(this.state.bid_increment) === Number(incr) ? 'bc-incr-btn--active' : ''}`}
                          onClick={() => {
                            this.setState({ bid_increment: incr });
                            this.setCurrentBidAmount(incr);
                          }}
                        >
                          {incr}
                        </button>
                      ))}
                    </div>
                    <button
                      className="bc-incr-arrow"
                      onClick={() => this.setState({ toggleArrow: true })}
                    >
                      <i className="fa fa-chevron-right" />
                    </button>
                  </div>
                </div>

                {/* Bid amount input */}
                <div className="bc-bid-input-section">
                  <span className="bc-bid-input-lbl">{i18n.t('latest_bid_amount')}</span>
                  <div className="bc-bid-input-row">
                    <button
                      className="bc-bid-step-btn"
                      disabled={this.state.left_button_disable}
                      onClick={this.decrementNumber}
                      type="button"
                    >
                      −
                    </button>
                    <input
                      type="number"
                      name="user_bid_amount"
                      className="bc-bid-input-field"
                      placeholder="Bid Amount"
                      value={this.state.user_bid_amount}
                      onChange={this.handleChange}
                      readOnly={true}
                    />
                    <button
                      className="bc-bid-step-btn"
                      onClick={this.incrementNumber}
                      type="button"
                    >
                      +
                    </button>
                  </div>
                </div>

                {/* Enroll prompts */}
                {is_logged && this.state.need_enroll && reg_status === 'open' && (
                  <>
                    {(this.state.enroll_status === 'N' ||
                      this.state.enroll_status === 'R' ||
                      this.state.enroll_status === '') && (
                      <>
                        <div className="bc-status-msg bc-status-msg--warning">
                          <i className="fa fa-clock-o" />
                          {i18n.t('msg_enroll_waiting')}
                        </div>
                        {!auction.is_enrolled && (
                          <Link to={'/enroll/' + auction.id} className="bc-enroll-btn">
                            <i className="fa fa-user-plus" />
                            {i18n.t('enroll')}
                          </Link>
                        )}
                      </>
                    )}
                    {this.state.enroll_status === 'N' && (
                      <div className="bc-status-msg bc-status-msg--danger">
                        <i className="fa fa-exclamation-circle" />
                        Your enrollment verification process is pending. Please contact
                        administrator.
                      </div>
                    )}
                  </>
                )}

                {this.state.enroll_status !== 'A' && reg_status === 'closed' && (
                  <div className="bc-status-msg bc-status-msg--danger">
                    <i className="fa fa-lock" />
                    {i18n.t('registration_closed')}
                  </div>
                )}

                {/* Bid Now */}
                {is_logged && !this.state.need_enroll && (
                  <>
                    <button
                      type="button"
                      className="bc-bid-btn"
                      onClick={this.bidNow}
                      disabled={this.state.is_bid_sending || this.state.bidTimeStopped}
                    >
                      {this.state.is_bid_sending ? (
                        <>
                          <span className="bc-bid-btn__spinner" />
                          Sending...
                        </>
                      ) : (
                        <>
                          <i className="fa fa-gavel" />
                          {i18n.t('bid_now')}
                        </>
                      )}
                    </button>

                    {/* Auto bidding panel */}
                    {Boolean(auction.has_auto_bidding) && (
                      <div className="bc-auto-panel">
                        <div className="bc-auto-panel-header">
                          <span className="bc-auto-panel-title">
                            <i className="fa fa-robot" style={{ color: '#0c8da2' }} />
                            {i18n.t('auto_bidding')}
                            <button
                              className="bc-info-btn"
                              onClick={() => this.setState({ show_auto_bid_info: true })}
                              type="button"
                            >
                              <i className="fa fa-info-circle" />
                            </button>
                          </span>
                          <button
                            className="bc-auto-panel-toggle-btn"
                            type="button"
                            onClick={() =>
                              this.setState({
                                show_auto_bid_panel: !this.state.show_auto_bid_panel,
                              })
                            }
                          >
                            <i
                              className={`fa fa-chevron-${this.state.show_auto_bid_panel ? 'up' : 'down'}`}
                            />
                          </button>
                        </div>

                        {this.state.show_auto_bid_panel && (
                          <div className="bc-auto-panel-body">
                            <div className="bc-toggle-row">
                              <span>{i18n.t('enable_auto_bidding')}</span>
                              <ToggleButton
                                inactiveLabel={i18n.t('no')}
                                activeLabel={i18n.t('yes')}
                                value={this.state.auto_bidding}
                                onToggle={(value) => {
                                  this.setState({ auto_bidding: !auto_bidding });
                                }}
                              />
                            </div>
                            <div className="bc-field-row">
                              <span>{i18n.t('incr_amount')}</span>
                              <select
                                name="auto_bid_increment"
                                value={this.state.auto_bid_increment}
                                onChange={this.handleChange}
                                className={
                                  !this.state.auto_bidding ? 'bc-select bg-disabled' : 'bc-select'
                                }
                                disabled={!this.state.auto_bidding}
                                style={{ width: '55%' }}
                              >
                                {increments.map((incr, i) => (
                                  <option key={i} value={incr}>
                                    {incr}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div style={{ fontSize: 12, color: '#6b7280', fontWeight: 500 }}>
                              {i18n.t('target_amount')}
                            </div>
                            <div className="bc-target-row">
                              <button
                                type="button"
                                className="bc-target-step"
                                onClick={this.decrementAutoBidNumber}
                                disabled={!this.state.auto_bidding}
                              >
                                −
                              </button>
                              <input
                                type="number"
                                name="target_amount"
                                className={
                                  !this.state.auto_bidding
                                    ? 'bc-target-input bg-disabled'
                                    : 'bc-target-input'
                                }
                                value={this.state.target_amount}
                                onChange={this.handleChange}
                                readOnly={true}
                                disabled={!this.state.auto_bidding}
                              />
                              <button
                                type="button"
                                className="bc-target-step"
                                onClick={this.incrementAutoBidNumber}
                                disabled={!this.state.auto_bidding}
                              >
                                +
                              </button>
                              <button
                                type="button"
                                className="bc-save-btn"
                                onClick={this.saveAutoBidOption}
                              >
                                {this.state.is_saving ? (
                                  <div
                                    className="spinner-border spinner-border-sm text-light"
                                    role="status"
                                  >
                                    <span className="sr-only">Loading...</span>
                                  </div>
                                ) : (
                                  <>
                                    <i className="fa fa-save" />
                                    &nbsp;{i18n.t('save')}
                                  </>
                                )}
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    )}

                    {/* Bid message */}
                    {this.state.bid_place_message && (
                      <div
                        className={`bc-alert ${this.state.bid_place_error ? 'bc-alert--danger' : 'bc-alert--success'}`}
                      >
                        {this.state.bid_place_message}
                      </div>
                    )}
                  </>
                )}
              </>
            )}
          </div>
        </div>

        {/* Login CTA */}
        {!is_logged && (
          <Link to="/login" className="bc-login-cta" style={{ marginTop: 12 }}>
            <i className="fa fa-sign-in" />
            {i18n.t('login_to_make_bids')}
          </Link>
        )}

        {/* Bidders position */}
        {is_logged && (
          <BiddersPositionNew
            top_bidders={this.state.top_bidders}
            loadTopBidders={this.loadTopBidders}
            refresh_loading={this.state.refresh_loading}
            user={user}
            total_enrolls={total_enrolls}
          />
        )}

        {/* Extra time modal */}
        {/* Extra time modal — only primary instance */}
        {this.props.isPrimary !== false && (
          <Modal
            contentClassName="bg-primary"
            style={{ zIndex: '99999' }}
            size="sm"
            show={this.state.extra_time_message}
            onHide={() => this.setState({ extra_time_message: false })}
          >
            <Modal.Header closeButton>
              <Modal.Title className="text-white">{i18n.t('message')}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-white">{i18n.t('extra_time_message')}</Modal.Body>
            <Modal.Footer>
              <button
                className="btn btn-light"
                onClick={() => this.setState({ extra_time_message: false })}
              >
                {i18n.t('close')}
              </button>
            </Modal.Footer>
          </Modal>
        )}

        {/* Auto bid info modal */}

        {this.props.isPrimary !== false && (
          <Modal
            contentClassName="rounded-2"
            style={{ zIndex: '99999' }}
            show={this.state.show_auto_bid_info}
            onHide={() => this.setState({ show_auto_bid_info: false })}
          >
            <Modal.Header closeButton>
              <Modal.Title className="h5">
                {i18n.t('information')} - {i18n.t('auto_bidding')}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-info">{i18n.t('information_auto_bidding')}</Modal.Body>
          </Modal>
        )}
      </React.Fragment>
    );
  }
}
